import Model from 'flarum/common/Model';

export default class LessonPlan extends Model {
  id = Model.attribute('id');
  title = Model.attribute('title');
  age_group = Model.attribute('age_group');
  
  procedure = Model.attribute('procedure');
  materials_required = Model.attribute('materials_required');
  children_may_interest = Model.attribute('children_may_interest');
  vocabulary_language = Model.attribute('vocabulary_language');
  
  activity_type_id = Model.attribute('activity_type_id');
  activity_type_id2 = Model.attribute('activity_type_id2');
  
  developmental_area_id = Model.attribute('developmental_area_id');
  developmental_area_id2 = Model.attribute('developmental_area_id2');

  activity_type = Model.attribute('activity_type');
  activity_type2 = Model.attribute('activity_type2');
  
  developmental_area = Model.attribute('developmental_area');
  developmental_area2 = Model.attribute('developmental_area2');
  
  learning_outcomes = Model.attribute('learning_outcomes');
  
  related_lesson_plans = Model.attribute('related_lesson_plans');
  related_to = Model.attribute('related_to');
  
  thumbnail = Model.attribute('thumbnail');
  pdf_file_name = Model.attribute('pdf_file_name');

  created_at = Model.attribute('created_at');
  updated_at = Model.attribute('updated_at');

  apiEndpoint() {
    return '/lesson-plans' + (this.exists ? '/' + this.data.id : '');
  }
}
